import React from "react";

const year = new Date().getFullYear();
const years = Array.from(new Array(5), (val, index) => year - index);
const yearList = years.map(x => {
  return <option key={x}>{x}</option>;
});

export default yearList;
